// Composer Studio — 노드 트리에서 id로 노드 찾기 (Phase 3a)
//
// 캔버스 클릭으로 얻은 data-composer-node-id를 템플릿 트리에서 역조회한다.
// group.children / stack.children / repeat.template / table cells의 content /
// branch 슬롯(branches[i].children)의 중첩 노드까지 재귀 탐색한다.
// (table cell 자체는 ComposerNode가 아니므로 셀 단위 선택은 미지원 — 셀 content 노드는 탐색.)

import type { ComposerNode } from '@safetyhub/report-composer';

/** 노드 1개와 그 하위(children/template/cell content)에서 id 매칭 노드 탐색 */
function findInNode(node: ComposerNode, id: string): ComposerNode | null {
  if (node.id === id) return node;

  switch (node.kind) {
    case 'group':
    case 'stack':
      return findInList(node.children, id);
    case 'repeat':
      return findInNode(node.template, id);
    case 'table': {
      for (const cell of node.cells) {
        if (cell.content) {
          const found = findInList(cell.content, id);
          if (found) return found;
        }
      }
      return null;
    }
    case 'branch': {
      for (const slot of node.branches) {
        const found = findInList(slot.children, id);
        if (found) return found;
      }
      return null;
    }
    default:
      return null;
  }
}

/** 노드 배열에서 첫 매칭 노드 탐색 */
function findInList(nodes: ComposerNode[], id: string): ComposerNode | null {
  for (const n of nodes) {
    const found = findInNode(n, id);
    if (found) return found;
  }
  return null;
}

/** 템플릿 body 트리 전체에서 id 매칭 노드 탐색 (없으면 null) */
export function findNodeById(body: ComposerNode[], id: string): ComposerNode | null {
  return findInList(body, id);
}
